import React, { useCallback } from 'react';
import * as Popover from '@radix-ui/react-popover';

import { PostComment } from '~/post/types';
import { useAppDispatch } from '~/store';
import { deleteCommentInUpdate } from '~/post/thunks/deleteCommentInUpdate';
import {
  CommentListWrapper,
  CommentsBadgeWrapper,
  CommentsIcon,
  Comments,
} from './styles';
import { Comment } from '../Comment';
import { AddComment } from '../AddComment';

type Props = {
  postId: string;
  comments: PostComment[];
};

export const CommentList = ({ postId, comments }: Props) => {
  const dispatch = useAppDispatch();
  const handleDeleteComment = useCallback(
    (commentId: string): void => {
      dispatch(deleteCommentInUpdate({ postId, commentId }));
    },
    [postId]
  );

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <CommentsBadgeWrapper hasComments={!!comments?.length}>
          <CommentsIcon />
        </CommentsBadgeWrapper>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          side="right"
          sideOffset={32}
          align="start"
          alignOffset={-60}
        >
          <CommentListWrapper>
            <Comments>
              <div>
                {comments.map((comment) => (
                  <Comment
                    comment={comment}
                    onDelete={() => handleDeleteComment(comment.id)}
                  />
                ))}
              </div>
            </Comments>
            <AddComment postId={postId} />
          </CommentListWrapper>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
